<template>
  <div>
    <!-- {{value}} -->
    <el-form-item label="提示文字">
      <el-input size="small" v-model="value.placeholder" placeholder="请输入" maxlength="50" show-word-limit/>
    </el-form-item>
    <el-form-item label="类型" class="radio-group-phone">
      <el-radio-group v-model="value.inputType">
          <el-radio label="phone"><span class="name-text">仅手机</span></el-radio>
          <el-radio label="tel"><span class="name-text">仅固话</span></el-radio>
          <el-radio label="both"><span class="name-text">手机或固话</span></el-radio>
        </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "PhoneInput",
  components: {},
  props:{
    value:{
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  data() {
    return {

    }
  },
  methods: {}
}
</script>

<style scoped>
.radio-group-phone /deep/ .el-radio{
  display: block;
  line-height: 28px;
}
</style>
